import { render, staticRenderFns } from "./DeleteItem.vue?vue&type=template&id=0c4116d2&scoped=true&"
import script from "./DeleteItem.vue?vue&type=script&lang=js&"
export * from "./DeleteItem.vue?vue&type=script&lang=js&"
import style0 from "./DeleteItem.vue?vue&type=style&index=0&id=0c4116d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4116d2",
  null
  
)

export default component.exports